/**
 * index.tsx
 * [Readme] --------------------------------------------------------------------------------------
 * 
 * 탑배너 컨테이너 정의
 * 
 * -----------------------------------------------------------------------------------------------
 */

import styled, { css } from 'styled-components';
import CloseButton from 'common-modules/general/assets/Desktop/images/common/ico_close02.png';
import { TopBannerModel } from 'common-modules/general/API/main/types';
import { APIClientBaseURL } from 'common-modules/general/Config/constants';

const Container = styled.div`
  position: relative;
`;

const Link = styled.a<{ isLink: boolean }>`
  cursor: ${props => (props.isLink ? 'pointer' : 'default')};
  &:before {
    content: '　';
    position: absolute;
    font-size: 0;
  }
`;

const ImgContainer = styled.div``;

const Img = styled.img`
  width: 100%;
  vertical-align: middle;
  border: 0;
  border-style: none;
`;

const TextContainer = styled.div<{ isMobile: boolean }>`
  ${props =>
    !props.isMobile &&
    css`
      z-index: 1;
      position: absolute;
      bottom: 1.9rem;
      right: 2.9rem;
      display: flex;
    `}

  ${props =>
    props.isMobile &&
    css`
      z-index: 1;
      position: absolute;
      top: 22px;
      top: 1.375rem;
      left: 19px;
      left: 1.1875rem;

      && span {
        vertical-align: 1px;
        margin-left: 25px;
        font-size: 13px;
        font-size: 0.8125rem;
      }
      && label {
        display: inline-block;
        padding: 0 11px 0 10px;
        padding: 0 0.6875rem 0 0.625rem;
        position: relative;
        -webkit-user-select: none;
        -moz-user-select: none;
        -ms-user-select: none;
        user-select: none;
      }
    `}
`;

const Input = styled.input`
  border: 0;
  clip: rect(0 0 0 0);
  width: 0.0625rem;
  height: 0.0625rem;
  margin: -0.0625rem;
  overflow: hidden;
  padding: 0;
  position: absolute;
`;
const Label = styled.label`
  padding: 0 0 0 27px;
  display: inline-block;
  position: relative;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  &:before {
    content: '';
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    position: absolute;
    top: 45%;
    left: 0;
    width: 20px;
    width: 1.25rem;
    height: 20px;
    height: 1.25rem;
    margin-top: -10px;
    margin-top: -0.625rem;
    border: 1px solid #aaa;
    text-align: center;
  }
  span {
    display: inline-block;
    vertical-align: middle;
    line-height: 1;
    color: #000;
    font-size: 18px;
    font-size: 1.125rem;
    margin-left: 0.625rem;
  }
`;

const CloseBannerContainer = styled.div<{ isMobile: boolean }>`
  ${props =>
    !props.isMobile &&
    css`
      margin-left: 2rem;
    `}

  ${props =>
    props.isMobile &&
    css`
      z-index: 1;
      cursor: pointer;
      position: absolute;
      top: 17px;
      top: 1.0625rem;
      right: 15px;
      right: 1.3125rem;
    `}
`;

const LabelContainer = styled.div`
  display: flex;
`;

const CloseIcon = styled.i<{ type: string }>`
  width: 1.1875rem;
  min-width: 1.1875rem;
  height: 1.1875rem;
  background: url(${CloseButton}) no-repeat 0 0;
  display: inline-block;
  cursor: pointer;

  transform: ${props => (props.type === '0' ? `scale(0.7)` : `scale(1)`)};
`;

const TextBackgroundContainer = styled.div<{ color: string; isMobile: boolean }>`
  display: flex;
  width: 100%;
  background-color: ${props => (props.color ? props.color : '#000')};
  padding: ${props => (props.isMobile ? '0.1rem 1rem ' : ' 0.1rem 3.8rem')};
  box-sizing: border-box;
`;

const TextTypeLabel = styled.div`
  width: 100%;
  color: white;
  font-size: 0.9rem;
  padding-right: 1rem;
`;

const NewPage = styled.a`
  color: white;
  text-decoration: underline;
  font-weight: bold;
  cursor: pointer;
  :hover {
    color: white;
  }
`;

interface Props extends TopBannerModel {
  src: string;
  isOpen: boolean;
  isMobile: boolean;
  onCloseToday(): void;
  onClose(): void;
}

const TopBanner = ({
  ynNewwdw,
  urlMvmt,
  isOpen,
  src,
  onCloseToday,
  onClose,
  isMobile,
  cntsBanr,
  typeOpn,
  typeGide
}: Partial<Props>) => {
  const handleClickView = () => {
    if (ynNewwdw === 'Y') {
      window.open(urlMvmt, '_blank');
    } else {
      window.open(urlMvmt, '_self');
    }
  };

  const textBackgroundColor = () => {
    if (typeGide === '0') {
      return '#1F4E79';
    } else if (typeGide === '1') {
      return '#6D5200';
    } else if (typeGide === '2') {
      return '#892307';
    } else {
      return '#1F4E79';
    }
  };

  const renderTextType = () => {
    return (
      <TextBackgroundContainer isMobile={isMobile || false} color={textBackgroundColor()}>
        <TextTypeLabel>
          {cntsBanr} {urlMvmt !== '' && <NewPage onClick={handleClickView}>보기</NewPage>}
        </TextTypeLabel>
        <CloseIcon type={typeOpn || '0'} onClick={onClose} />
      </TextBackgroundContainer>
    );
  };

  const renderImageType = () => {
    return (
      <Container id={'top-banner'}>
        <TextContainer isMobile={isMobile || false}>
          <LabelContainer>
            <Input type={'checkbox'} id={'layerClose'} onClick={onCloseToday} />
            <Label htmlFor="layerClose">
              <span>오늘 하루 열지 않기</span>
            </Label>
          </LabelContainer>

          {!isMobile && (
            <CloseBannerContainer isMobile={isMobile || false} onClick={onClose}>
              <CloseIcon type={typeOpn || '0'} />
            </CloseBannerContainer>
          )}
        </TextContainer>

        {isMobile && (
          <CloseBannerContainer isMobile={isMobile} onClick={onClose}>
            <CloseIcon type={typeOpn || '0'} />
          </CloseBannerContainer>
        )}
        <ImgContainer>
          <Link isLink={urlMvmt !== ''} onClick={handleClickView}>
            <Img src={`${APIClientBaseURL.file}${src}`} />
          </Link>
        </ImgContainer>
      </Container>
    );
  };

  return isOpen ? (typeOpn === '1' ? renderImageType() : renderTextType()) : null;
};

export default TopBanner;
